export type MediaType = 'image' | 'video' | 'audio' | 'document' | 'text';

export default function (contentType: string): MediaType {
  if (contentType.startsWith('image/')) return 'image';
  if (contentType.startsWith('video/')) return 'video';
  if (contentType.startsWith('audio/')) return 'audio';
  if (contentType === 'application/pdf') return 'document';
  if (contentType.startsWith('text/')) return 'text';
  return 'document';
}
